exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n::-webkit-scrollbar {\n    width: 10px; /* 设置滚动条宽度 */\n    height: 10px; /* 设置滚动条高度 */\n}\n::-webkit-scrollbar-thumb {\n    background-color: #cccccc; /* 设置拖动条颜色 */\n}\n::-webkit-scrollbar-track {\n    background-color: #f2f2f2; /* 设置滚动条背景颜色 */\n}\n", ""]);

// exports
